const small_screen_width = 768;

export { small_screen_width };
